import { InventoryTwoTone } from "@mui/icons-material";

const InventoryIcon = () => {
  return <InventoryTwoTone />;
};

export default InventoryIcon;
